import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "current-step" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Layout1 = _resolveComponent("Layout1")!
  const _component_Layout6 = _resolveComponent("Layout6")!
  const _component_Layout2 = _resolveComponent("Layout2")!
  const _component_Layout3 = _resolveComponent("Layout3")!
  const _component_Layout4 = _resolveComponent("Layout4")!
  const _component_Layout5 = _resolveComponent("Layout5")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_Layout1, {
      user: $setup.unifiedUser,
      message: $props.messages[$props.currentStep - 1],
      animationIsReverse: $setup.animationIsReverse,
      "onUpdate:user": _cache[0] || (_cache[0] = ($event: any) => ($setup.updateUser($event)))
    }, null, 8, ["user", "message", "animationIsReverse"]), [
      [_vShow, $props.currentStep === 1]
    ]),
    _withDirectives(_createVNode(_component_Layout6, {
      user: $setup.unifiedUser,
      message: $props.messages[$props.currentStep - 1],
      animationIsReverse: $setup.animationIsReverse,
      "onUpdate:user": _cache[1] || (_cache[1] = ($event: any) => ($setup.updateUser($event)))
    }, null, 8, ["user", "message", "animationIsReverse"]), [
      [_vShow, $props.currentStep === 2]
    ]),
    _withDirectives(_createVNode(_component_Layout2, {
      user: $setup.unifiedUser,
      message: $props.messages[$props.currentStep - 1],
      animationIsReverse: $setup.animationIsReverse
    }, null, 8, ["user", "message", "animationIsReverse"]), [
      [_vShow, $props.currentStep < 6 && $props.currentStep !== 1 && $props.currentStep !== 2]
    ]),
    _withDirectives(_createVNode(_component_Layout3, {
      interests: $props.interests,
      "user-interests": $setup.userInterest,
      message: $props.messages[$props.currentStep - 1],
      animationIsReverse: $setup.animationIsReverse,
      "onUpdate:userInterests": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:userInterests', $event)))
    }, null, 8, ["interests", "user-interests", "message", "animationIsReverse"]), [
      [_vShow, $props.currentStep === 6]
    ]),
    _withDirectives(_createVNode(_component_Layout4, {
      user: $setup.unifiedUser,
      message: $props.messages[$props.currentStep - 1],
      animationIsReverse: $setup.animationIsReverse,
      "onUpdate:user": _cache[3] || (_cache[3] = ($event: any) => ($setup.updateUser($event)))
    }, null, 8, ["user", "message", "animationIsReverse"]), [
      [_vShow, $props.currentStep === 7]
    ]),
    _withDirectives(_createVNode(_component_Layout5, {
      message: $props.messages[$props.currentStep - 1],
      animationIsReverse: $setup.animationIsReverse
    }, null, 8, ["message", "animationIsReverse"]), [
      [_vShow, $props.currentStep === 8]
    ])
  ]))
}